// eslint-disable-next-line no-shadow
export const enum SubscriptionPlan {
  Regular,
  Pro,
}
